<template>
  <div class="home small-container" v-if="current">
    <h5><img :src="current.icone"><span>{{ t('QRCODE_TITULO') }}</span></h5>

    <router-link class="comprar btn block" :to="{name: 'bilhete-especial-comprar'}">{{ t('QRCODE_COMPRAR_BILHETE') }}</router-link>

    <p>{{ t('QRCODE_ORIENTACOES', [current.nome]) }}</p>

    <router-link class="comprados btn block"  :to="{name: 'bilhete-especial-comprados'}">{{ t('QRCODE_ACESSAR_BILHETES') }}</router-link>

    <a class="saber-mais btn block" @click="openExternal(current.linkSaibaMais, true)">
      <img src="../../assets/img/info-branca.png"/>{{ t('QRCODE_SABER_MAIS', [current.nome]) }}
    </a>
  </div>
</template>

<style lang="scss">
  @import url('./QRCode.scss');
</style>

<script>
import { translate } from '../../services/translate.service';
import * as service from '../../services/qrcode.service';
import { baseUrl } from '../../helpers/helpers'
import { types } from '../../store';
export default {
  name: 'bilhete-especial',
  props: { },
  components: { },
  data() {
    return {
    }
  },
  methods:{
    t:translate,
    openExternal: function(url, blank) {
      window.open(url, blank ? '_blank' : '_self');
    }
  },
  computed: {
    current() {
      return this.$store.state.qrcode_current || null;
    }
  },
  created(){
  },
  mounted() {
    if(!this.current) {
      service.getEventoAtivo().then(res => {
        let icone = `${ baseUrl }/getimages/${res.data.icone.path}`;
        res.data.icone = icone;
        
        if(res.data.logoPatrocinio) {
          res.data.logoPatrocinio =  `${ baseUrl }${res.data.logoPatrocinio.imageUrl}`;
        }
        if(res.data.banner) {
          res.data.banner =  `${ baseUrl }${res.data.banner.imageUrl}`;
        }
        this.$store.dispatch(types.SET_QRCODE_CURRENT, res.data);
      }).catch(() => {
        this.$router.push({ name: 'home' });
      });
    }
  }
}
</script>
